import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {getLeagueModesWithNames} from '../../../helpers/league';
import './index.css';

class FilterLeague extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.initialValues;
  }

  updateField(name, value) {
    const field = {[name]: value};
    this.setState(field);
    this.props.onChange({...this.state, ...field});
  }

  toggleNbPlayers(nbPlayers) {
    const state = [...this.state.nbPlayers];
    const selected = state.indexOf(nbPlayers);

    if (selected > -1) {
      state.splice(selected, 1);
    } else {
      state.push(nbPlayers);
    }

    this.updateField('nbPlayers', state);
  }

  toggleMode(mode) {
    const state = [...this.state.mode];
    const selected = state.indexOf(mode);

    if (selected > -1) {
      state.splice(selected, 1);
    } else {
      state.push(mode);
    }

    this.updateField('mode', state);
  }

  renderField(field, key) {
    const btnCln = 'btn btn-xs';
    switch (field) {
      case 'nbPlayers':
        const nbPlayers = [2, 4, 6, 8, 10];
        return (
          <div key={key} className="league-filter-field">
            {nbPlayers.map(nb => (
              <button
                key={`league-filter-nbPlayers-${nb}`}
                onClick={() => this.toggleNbPlayers(nb)}
                className={classNames(btnCln, 'btn-nbPlayers', {
                  'btn-default': !this.state.nbPlayers.includes(nb),
                  'btn-primary': this.state.nbPlayers.includes(nb),
                })}>
                {nb}
              </button>
            ))}
          </div>
        );
      // Ces boutons pourraient permettre de filtrer par :
      // - ordi (mode jeu contre un bot)
      // - publique auto
      // - ultra (ancien mode ultra)
      // /!\ Ne sont pas accessibles actuellement côté back

      case 'mode':
        const modes = getLeagueModesWithNames();
        const isNormalOrExpert = modeKey =>
          modes[modeKey] === 'Normal' || modes[modeKey] === 'Expert';
        return (
          <div key={key} className="league-filter-field">
            {Object.keys(modes).map(modeKey => {
              return (
                isNormalOrExpert(modeKey) && (
                  <button
                    key={`league-filter-mode-${modeKey}`}
                    onClick={() => this.toggleMode(modeKey)}
                    className={classNames(btnCln, 'btn-mode', {
                      'btn-default': !this.state.mode.includes(modeKey),
                      'btn-primary': this.state.mode.includes(modeKey),
                    })}>
                    {modes[modeKey]}
                  </button>
                )
              );
            })}
          </div>
        );
      default:
        return false;
    }
  }

  render() {
    const {label, initialValues} = this.props;
    return (
      <div className="league-filter inline">
        {label && [
          <label key="league-filter-label-1">{label}</label>,
          <br key="league-filter-label-2" />,
        ]}
        {Object.keys(initialValues).map((field, i) =>
          this.renderField(field, `league-filter-field-${i}`),
        )}
      </div>
    );
  }
}

FilterLeague.propTypes = {
  initialValues: PropTypes.shape({
    nbPlayers: PropTypes.arrayOf(PropTypes.number),
    mode: PropTypes.arrayOf(PropTypes.number),
  }),
  onChange: PropTypes.func.isRequired,
};

FilterLeague.defaultProps = {
  initialValues: {nbPlayers: [], mode: []},
};

export default FilterLeague;



// WEBPACK FOOTER //
// ./src/components/Filters/League/index.js